import { Identifiable, CalendarHolidays, Planzone } from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";

function getDefaultCalendarHolidays(httpClient: HttpClient) {
  return (planzone: Planzone) =>
    httpClient
      .sendHttpRequest<Identifiable<CalendarHolidays>>({
        endpoint: `/planzones/${planzone.uuid}/defaultCalendarHolidays`,
        method: HttpMethods.GET,
      })
      .then((response) => response);
}

export { getDefaultCalendarHolidays };
